import React from 'react';

type Props = {
  email: string;
};

const EmailLink: React.FC<Props> = ({ email }) => {
  return (
    <a
      className="text-table-light-gray m-0"
      href={`mailto:${email}`}
    >
      {email}
    </a>
  );
};

export default EmailLink;
